import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="overflow-hidden border-t border-purple-900/30 px-4 pb-10 pt-16 sm:px-8 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <motion.p
          data-testid="footer-logo"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="text-center font-display text-[22vw] uppercase leading-none tracking-wide text-stroke-gold sm:text-[14vw] lg:text-[10rem]"
        >
          B3B
        </motion.p>
        <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-purple-900/30 pt-6 sm:flex-row">
          <p data-testid="footer-copyright" className="font-mono-b3b text-[10px] uppercase tracking-[0.25em] text-slate-500">
            © 2026 B3B Basketball — Built for the streets
          </p>
          <p className="font-mono-b3b text-[10px] uppercase tracking-[0.25em] text-slate-500">
            4 teams. 1 court. No mercy.
          </p>
        </div>
      </div>
    </footer>
  );
}
